export default (state = false, { type, payload }) => {
    switch (type) {
        case 'START_HUNT_PLANNER_LOADER':
            return true
        case 'STOP_HUNT_PLANNER_LOADER':
            return false
        case 'LOGOUT':
            return false
        default:
            return state
    }
}